import L from "leaflet";
import { GridLayer, withLeaflet } from "react-leaflet";
import "leaflet.gridlayer.googlemutant";

const SCRIPT_ID = "google-maps-js-api";
const API_KEY = process.env.REACT_APP_GOOGLE_MAPS_KEY || "";

function loadGoogleMapsApi() {
  if (typeof window === "undefined") return;
  if (window.google && window.google.maps) return;
  if (document.getElementById(SCRIPT_ID)) return;
  const script = document.createElement("script");
  script.id = SCRIPT_ID;
  script.async = true;
  script.defer = true;
  script.src = `https://maps.googleapis.com/maps/api/js?key=${encodeURIComponent(API_KEY)}`;
  document.head.appendChild(script);
}

class GoogleLayer extends GridLayer {
  createLeafletElement(props) {
    loadGoogleMapsApi();
    return L.gridLayer.googleMutant({
      type: props.type || "roadmap",
      ...this.getOptions(props),
    });
  }
}

export default withLeaflet(GoogleLayer);
